import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  icons: {
    display: "flex",
    height: "55px",
    alignItems: "start",
    gap: "15px",
    "& a svg .a": {
      fill: theme.palette.white,
    },
  },
  scrollable: {
    overflowY: "auto",
  },
  box: {
    paddingBottom: "20px",
  },

  container: {
    padding: "0 80px 50px",
    [theme.breakpoints.down("md")]: {
      padding: "0 20px",
    },
  },

  header: {
    display: "flex",
    justifyContent: "flex-start",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
  },
  edit: {
    paddingLeft: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    gap: "10px",
    alignItems: "flex-start",
    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
      textAlign: "center",
      alignItems: "center",
      paddingLeft: 0,
    },
  },

  itemCell: {
    marginTop: theme.spacing(3),
    minWidth: "100px",
    overflow: "hidden",
    marginRight: theme.spacing(2),
  },
  itemValue: {
    marginTop: theme.spacing(1),
    lineHeight: "21px",
  },

  avatar: {
    width: "130px !important",
    height: "130px !important",
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(3),
    },
  },
  companyContainer: {
    marginTop: "40px",
    paddingTop: theme.spacing(3),
    borderTop: `1px solid ${theme.palette.gray.medium}`,
  },
  companyImage: {
    width: "60px",
    height: "60px",
    paddingRight: theme.spacing(3),
  },
  linkIcons: {
    color: theme.palette.white,
    width: "30px",
    height: "30px",
  },
}));
